// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__WihwO","col":"styles_col__1ynOb"};